import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const PaymentDashboardRBAC = {
  pageID: '5b3e710495118938df4da406dd0c7b8f',
  elementID: {
    ViewPage: 'f9714d477ff9f20c7a1bd0b03060a189',
    Detail: 'f33db61b80ba7949856247cc24169b18',
  },
} as const

export const useRBACPaymentDashboardRBACPage = createUseRBAC(PaymentDashboardRBAC.elementID)

export type UseRBACPaymentDashboardRBACPageType = ReturnType<typeof useRBACPaymentDashboardRBACPage>
